export const ANONYMOUS_NAME = '(anonymous)';

const QUEENSLAND_STAGING_PARTNER_ID = 11277;
const QUEENSLAND_PARTNER_ID = 15362;
export const PARTNER_IDS = {
  QLEARN: [QUEENSLAND_STAGING_PARTNER_ID, QUEENSLAND_PARTNER_ID],
};
